// Wave IX.A · AI Economy · ReputationBadge topbar widget.
// V12 Achromatic Strict · tier color scale fully neutral (dark→light).
// Fetches /api/v2/ai-economy/reputation/me on mount. Silent fallback on error.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shield, ShieldCheck } from "lucide-react";
import { API } from "@/lib/api";

async function apiGet(path) {
    const r = await fetch(`${API}${path}`, { credentials: "include" });
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
}

const TIER_STYLE = {
    bronze:   { label: "Bronze",   cls: "border-neutral-800 bg-neutral-950 text-neutral-500" },
    silver:   { label: "Silver",   cls: "border-neutral-700 bg-neutral-900 text-neutral-400" },
    gold:     { label: "Gold",     cls: "border-neutral-500 bg-neutral-800 text-neutral-200" },
    platinum: { label: "Platinum", cls: "border-neutral-200 bg-neutral-100 text-neutral-900" },
};

export default function ReputationBadge() {
    const [rep, setRep] = useState(null);
    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const d = await apiGet("/v2/ai-economy/reputation/me");
                if (!cancelled) setRep(d);
            } catch (_) { /* silent */ }
        })();
        return () => { cancelled = true; };
    }, []);
    if (!rep) return null;
    const tier = rep.tier || "bronze";
    const style = TIER_STYLE[tier] || TIER_STYLE.bronze;
    const trust = rep.benefits?.trust_badge;
    return (
        <Link
            to="/app/reputation"
            title={`Reputation · ${rep.score}/1000 · ${style.label}`}
            data-testid="reputation-badge"
            className={`inline-flex items-center gap-1 rounded-md border px-2 py-1 text-[11px] transition-colors ${style.cls}`}
        >
            {trust ? <ShieldCheck className="h-3 w-3" /> : <Shield className="h-3 w-3" />}
            <span className="font-medium">{style.label}</span>
            <span className="opacity-70">· {rep.score}</span>
        </Link>
    );
}
